<template>
	<div class="component">
		<GameList :preview="preview" />
		<button @click="$emit('close')" class="btn-close">
			<i class="fa fa-times" aria-hidden="true"></i>
		</button>
	</div>
</template>

<script>
import GameList from '@/components/Games/Wrapper'
export default {
	name: 'preview',
	created() {
		window.onkeydown = e => {
			if (e.key === 'Escape') this.$emit('close')
		}
	},
	beforeDestroy() {
		window.onkeydown = null
	},
	props: ['preview'],
	components: {
		GameList,
	},
}
</script>

<style lang="scss" scoped>
.component {
	background: rgba(#000, 0.5);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
	padding: 2%;
	z-index: 10;

	& > * {
		height: 100%;
	}

	.btn-close {
		position: absolute;
		top: 30px;
		display: flex;
		align-items: start;
		right: 30px;
		font-size: 25px;
		width: 30px;
		height: 30px;
		border-radius: 4px;
		color: rgba(#000, 1);
		border: none;
		background-color: rgba(#fff, 0.8);
	}
}
</style>
